import { Product } from '@uds/product';
import { ecommerce } from '@uds/tagmg';
import { Maybe } from 'core';
import { Analytics } from 'domain/constants/ribbons';
import { promoNameToPromoId } from 'domain/logic/promotion';
import { getProductData } from 'infrastructure/cta';

type Impression = [
  string,
  {
    id: number;
    name: string;
    list?: string;
  },
];

const getProductIds = (productIds: Maybe<string> = '') =>
  (productIds ?? '')
    .toString()
    .split(',')
    .map((id: string) => id.trim())
    .filter(Boolean)
    .map((productId) => ({ productId }));

export const sendProductDetail = async (analytics: Analytics) => {
  const { productId } = analytics ?? {};
  const productIds = getProductIds(productId);
  const promises = productIds.map(getProductData);
  const products = await Promise.all(promises);
  const impressions = products.map((product: Product) => {
    const impression: Impression = [
      'addProduct',
      {
        id: product.id,
        name: product.name,
      },
    ];
    return impression;
  });
  ecommerce([...impressions, ['setAction', 'detail']], { nonInteraction: true });
};

export const sendProductImpression = async (analytics: Analytics, list: string) => {
  const { productId } = analytics ?? {};
  const productIds = getProductIds(productId);
  const promises = productIds.map(getProductData);
  const products = await Promise.all(promises);
  const impressions = products.map((product: Product) => {
    const impression: Impression = [
      'addImpression',
      {
        id: product.id,
        name: product.name,
        list,
      },
    ];
    return impression;
  });
  ecommerce(impressions, { nonInteraction: true });
};

export const sendPromotionImpression = (analytics: Analytics, list: string) => {
  const { promotion } = analytics ?? {};

  if (promotion == null || promotion === '') {
    return null;
  }

  const promoId = promoNameToPromoId(promotion);
  ecommerce(
    [
      [
        'addImpression',
        {
          id: promoId,
          name: promotion,
          list,
        },
      ],
    ],
    { nonInteraction: true },
  );
};
